import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  title: 'Entry point',
  attributeName: 'dynamicGraphics',
  helpText: 'This section is to control how many and what content will appear in the Main Hub. It can be reorganized into different forms',
  fields: [
    // {
    //   attributeName: 'graphicsManifestURL',
    //   type: FormInputTypes.DOWNLOADABLE,
    //   label: 'Graphics Manifest URL',
    //   helpText: 'URL to the graphics manifest for the mainhub. To learn more about graphics manifest, please refer to the “Graphics Manifest” documentation.',
    //   fileType: ['.json'],
    // },

    {
      attributeName: 'roomName',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Space',
      helpText: 'Name of the Space selected as Entry point.',
      disabled:true
    },
    {
      attributeName: 'roomLink',
      label:'Entry Point Canvas Link',
      type: FormInputTypes.LINK,
      icon: IconType.ARROW_RIGHT,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Link to the corresponding Space.',
    },   

  ],
};
